import { z } from 'zod'

export const DeedmtgDataSchema = z.object({
  buyer_borrower1_corp_ind: z.string().nullable(),
  buyer_borrower2_corp_ind: z.string().nullable(),
  seller1_corp_ind: z.string().nullable(),
  seller2_corp_ind: z.string().nullable(),
  transaction_type: z.string().nullable(),
  fa_transaction_id: z.string().nullable(),
  recording_date: z.string().nullable(),
})
export type DeedmtgData = z.infer<typeof DeedmtgDataSchema>
